import {BROADCAST_TYPE} from '@/constants/channel';
import {NODECommonApi, PHPCommonApi} from '../common';
import {
  LikePostParams,
  PostListQueryParams,
  LikePostResponse,
  PostListResponse,
  POST_LIST_FIELD,
  DeletePostParams,
  CancelNoticeParams,
  GetFixToHomeParams,
  SetFixToHomeParams,
  GetFixToHomeResponse,
  GetPostMoveParams,
  GetReportListParams,
  GetReportListResponse,
  ReportPostParamsSchema,
  ReportPostResponse,
  ReportPostErrorResponse,
  DeletePinParamsSchema,
  DeleteLikePostParams,
  AddFavoriteParamsSchema,
  AddFavoriteResponse,
  BlindPostParamsSchema,
  BlindPostResponseSchema,
  DeletePostListParams,
} from '@/types/channel/board/board.schema';

export const getPostList = async (params: PostListQueryParams) => {
  const {userId, ...query} = params;

  return PHPCommonApi.get<PostListResponse>(
    `/${userId}/board/${params.boardNumber || ''}`,
    {
      ...query,
      perPage: 20,
      field: POST_LIST_FIELD,
    },
  );
};

export const likePost = async (params: LikePostParams) => {
  const {userId, postId, boardType} = params;

  return NODECommonApi.post<LikePostResponse>(
    `/${userId}/post/${postId}/like`,
    {
      boardType: boardType || 104,
    },
    {},
  );
};

/**
 * 게시글 다중 선택 삭제 API
 */
export const deletePostList = async (params: DeletePostListParams) => {
  const {userId, postIds} = params;

  return PHPCommonApi.post(
    `/${userId}/board/1`,
    {
      _method: 'delete',
      title_lists: JSON.stringify(postIds),
    },
    {},
  );
};

export const deletePost = async (params: DeletePostParams) => {
  const {userId, postId} = params;

  return PHPCommonApi.post(
    `/${userId}/title/${postId}`,
    {
      _method: 'delete',
    },
    {},
  );
};

export const deleteVodPost = async (params: DeletePostParams) => {
  const {userId, postId} = params;

  return PHPCommonApi.post(
    `/${userId}/vod/${postId}`,
    {
      _method: 'delete',
    },
    {},
  );
};

export const deleteVodBlind = async (params: DeletePostParams) => {
  const {userId, postId} = params;

  return PHPCommonApi.post(
    `/${userId}/vod/blind/${postId}`,
    {
      _method: 'delete',
    },
    {},
  );
};

/**
 * 공지 해제
 */
export const cancelNotice = async (params: CancelNoticeParams) => {
  const {userId, postId} = params;

  return PHPCommonApi.post(
    `/${userId}/title/${postId}/notice/${postId}`,
    {
      _method: 'put',
    },
    {},
  );
};

/**
 * 홈 고정 가능 여부 조회
 */
export const getFixToHome = async (params: GetFixToHomeParams) => {
  const {userId, titleNo} = params;
  return PHPCommonApi.get<GetFixToHomeResponse>(`/${userId}/pin/${titleNo}`);
};

/**
 * 홈 고정 설정
 */
export const setFixToHome = async (params: SetFixToHomeParams) => {
  const {userId, titleNo} = params;

  return PHPCommonApi.post<GetFixToHomeResponse>(
    `/${userId}/pin/${titleNo}`,
    {
      expireDate: params.expireDate,
    },
    {},
  );
};

/**
 * 홈 고정 해제
 */
export const deletePin = async (params: DeletePinParamsSchema) => {
  const {userId, postId} = params;
  return PHPCommonApi.post(
    `/${userId}/pin/${postId}`,
    {
      _method: 'delete',
    },
    {},
  );
};

export const getPostMoveAvaliable = async (params: GetPostMoveParams) => {
  const {userId, postId, oldBbsId, newBbsId} = params;
  return PHPCommonApi.post(
    `/${userId}/board/moveselect`,
    {
      title_lists: JSON.stringify(postId),
      bbs_no: newBbsId,
      old_bbs_no: oldBbsId,
    },
    {},
  );
};

export const setPostMove = async (params: GetPostMoveParams) => {
  const {userId, postId, oldBbsId, newBbsId} = params;
  return PHPCommonApi.post(
    `/${userId}/board/move`,
    {
      _method: 'put',
      title_lists: JSON.stringify(postId),
      bbs_no: newBbsId,
      old_bbs_no: oldBbsId,
    },
    {},
  );
};

export const getReportList = async (params: GetReportListParams) => {
  const {userId} = params;
  return PHPCommonApi.get<GetReportListResponse>(`/${userId}/report`, {
    isStationReport: params.isStationReport,
  });
};

export const reportPost = async (params: ReportPostParamsSchema) => {
  const {userId} = params;
  return PHPCommonApi.post<ReportPostResponse | ReportPostErrorResponse>(
    `/${userId}/report`,
    {
      _token: '',
      writerId: params.writerId,
      commonIdx: params.commonIdx,
      boardType: params.boardType,
      mode: params.mode,
      isStationReport: params.isStationReport,
      reportInfoNo: params.reportInfoNo,
      comment: params.comment,
    },
    {},
  );
};

export const deleteLikePost = async (params: DeleteLikePostParams) => {
  const {userId, postId} = params;

  return NODECommonApi.delete<LikePostResponse>(
    `/${userId}/post/${postId}/like`,
    {},
    {},
  );
};

export const addFavorite = async (params: AddFavoriteParamsSchema) => {
  return PHPCommonApi.post<AddFavoriteResponse>('/favorite', params, {});
};

export const getFavoriteState = async (params: {userId: string}) => {
  return PHPCommonApi.get<{isFavorite: boolean}>(`/favorite/${params.userId}`);
};

export const deleteFavorite = async (params: {userId: string}) => {
  return PHPCommonApi.post<{
    message: string | undefined;
    isFavorite: boolean;
  }>(
    `/favorite/${params.userId}`,
    {
      _method: 'delete',
    },
    {},
  );
};

export const addFavoriteAlarm = async (params: {userId: string}) => {
  return PHPCommonApi.post<{bjNick: string; message: string}>(
    `/favorite/push`,
    {
      bj_id: params.userId,
      _token: '',
    },
    {},
  );
};

export const deleteFavoriteAlarm = async (params: {userId: string}) => {
  return PHPCommonApi.post<{bjNick: string; message: string}>(
    `/favorite/push/${params.userId}`,
    {
      bj_id: params.userId,
      _method: 'delete',
      _token: '',
    },
    {},
  );
};

export const blindPost = async (params: BlindPostParamsSchema) => {
  return PHPCommonApi.get<BlindPostResponseSchema>(
    `/${params.userId}/title/${params.postId}/blind`,
    {
      blindId: params.postUserId,
    },
  );
};
